'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react'),
    connect = require('react-redux').connect;

var FlashMessage = React.createClass({
	displayName: 'FlashMessage',

	propTypes: {
		type: React.PropTypes.oneOf(['error', 'info', 'success']).isRequired,
		message: React.PropTypes.string.isRequired
	},

	render: function render() {
		return React.createElement(
			'div',
			{ className: 'flash alert-' + this.getAlertType() },
			this.props.message
		);
	},

	getAlertType: function getAlertType() {
		if (this.props.type === 'error') {
			return 'danger';
		}

		return this.props.type;
	}
});

var FlashMessages = React.createClass({
	displayName: 'FlashMessages',

	propTypes: {
		flashMessages: React.PropTypes.array.isRequired
	},

	render: function render() {
		return React.createElement(
			'div',
			null,
			this.props.flashMessages.map(function (message, index) {
				return React.createElement(FlashMessage, _extends({}, message, { key: index }));
			})
		);
	}
});

module.exports = connect(function mapStateToProps(state) {
	return {
		flashMessages: state.dialogs.flashMessages
	};
})(FlashMessages);


//////////////////
// WEBPACK FOOTER
// ./client/components/FlashMessages.js
// module id = 171
// module chunks = 5